window.isProd = () => {
  return document.location.hostname.indexOf('.com') != -1;
}

export default {
  apiUrl: isProd() ? 'https://www.flowra.com/api' : 'https://localhost:4000/api'
}
